<template>
	<div class="bdtrade">
		<a-layout id="components-layout-demo-side" style="min-height: 100vh">
			<menuBar :current="current" :openKeys="openKeys" ></menuBar>
			<a-layout style="overflow: auto;">
				<topBar></topBar>
				<a-layout-content style="margin: 16px; min-width: 1192px;">
					<div style="font-size: 20px;line-height: 30px;margin-bottom: 10px;font-weight: 700;padding-left: 8px;">查看订单</div>
					<div class="contentcard">
						<div style="font-size: 14px; font-weight: 700;">订单搜索</div>
						<a-divider dashed style="margin: 10px 0;" />
						<div style="margin-bottom: 20px;">
							<div style="margin-bottom: 20px;">
								<div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">订单号</span>
									<a-input placeholder="请输入订单号" style="width: 260px" v-model="searchlist.trade_id" />
								</div>
								<div style="width: 500px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">订单时间</span>
									<a-range-picker :defaultValue="[moment(startdate, dateFormat), moment(enddate, dateFormat)]" @change="changetime" />
								</div>
								<!-- <div style="width: 400px;display: inline-block;">
									<span style="font-size: 14px; font-weight: 700;display: inline-block;width: 100px;text-align: right;margin-right: 30px;">订单号</span>
									<a-input placeholder="请输入订单号" style="width: 260px" v-model="searchlist.status" />
								</div> -->
							</div>
						</div>
						<div style="text-align: center;">
							<a-button type="primary" style="width: 96px;" @click="searchbtn">搜索</a-button>
						</div>
					</div>
					<div class="contentcard">
						<div style="padding-bottom: 50px;">
							<div>
								<div v-if="!tradelist.length">
									<a-alert message="查询结果为空" banner type="info" />
								</div>
								<div v-if="tradelist.length">
									<a-row type="flex" justify="space-around" align="middle" style="background-color: #f3f3f5;font-size: 14px;height: 60px;font-weight: 700;">
										<a-col :span="6" style="text-align: center;">订单号</a-col>
										<a-col :span="6" style="text-align: center;">商品名称</a-col>
										<a-col :span="2" style="text-align: center;">订单总金额</a-col>
										<a-col :span="5" style="text-align: center;">下单时间</a-col>
										<a-col :span="2" style="text-align: center;">订单状态</a-col>
										<a-col :span="3" style="text-align: center;">操作</a-col>
									</a-row>
								</div>
								<div style="color: #666;font-size: 14px;" v-for="(item,index) in tradelist" :key="index">
									<a-row type="flex" justify="space-around" align="middle" style="border: #e8e8e8 solid 1px; border-top: none;padding: 10px 0;">
										<a-col :span="6" style="text-align: center;">{{item.trade_number}}</a-col>
										<a-col :span="6" style="text-align: center;">
											<span v-if="item.TC_Orders[0].sku_title.length>12">{{item.TC_Orders[0].sku_title.substring(0, 12)+'…'}}</span>
											<span v-else>{{item.TC_Orders[0].sku_title.substring(0, 10)}}</span>
											<span v-if="item.TC_Orders.length>1">{{'等'+item.TC_Orders.length+'件商品'}}</span>
										</a-col>
										<a-col :span="2" style="text-align: center;">{{'￥'+item.total_price/100}}</a-col>
										<a-col :span="5" style="text-align: center;">{{moment(item.created_at).format("YYYY-MM-DD HH:mm:ss")}}</a-col>
										<a-col :span="2" style="text-align: center;">{{status[item.status]}}</a-col>
										<a-col :span="3" style="text-align: center;">
											<a-button ghost size="small" type="primary" style="width: 96px;font-size: 12px;" @click="gotodetails(item.id)">详情</a-button>
										</a-col>
									</a-row>
								</div>
							</div>
							<div style="float: right;position: relative;bottom: -18px;">
								<a-pagination showSizeChanger @showSizeChange="onShowSizeChange" :current="endpage/pageSize" :pageSize="pageSize" :total="tradesum"
								 showQuickJumper @change="pageChange" />
							</div>
						</div>
					</div>
				</a-layout-content>
				<bottomBar></bottomBar>
			</a-layout>
		</a-layout>
		<div>
			<a-back-top />
		</div>
	</div>
</template>

<script>
	import moment from 'moment';

	export default {

		data() {
			return {
				current: ['bdmanagement'],
				openKeys: ['bdmodule'],
				dateFormat: 'YYYY-MM-DD',
				startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
				enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
				searchlist: {
					trade_id: null,
					startdate: this.moment().startOf('month').format("YYYY-MM-DD"),
					enddate: this.moment().endOf('month').format("YYYY-MM-DD"),
					// status:null,
				},
				shopkeeper_id:this.$route.query.shopkeeper_id,
				tradelist: [],
				tradesum: 0,
				startpage: this.$route.query.startpage || 0,
				endpage: this.$route.query.endpage || 10,
				pageSize: Number(this.$route.query.pageSize) || 10,
				status: {
					'to_be_paid': '待付款',
					'have_paid': '待发货',
					'delivery': '已发货',
					'finished': '已完成',
					'success': '交易成功',
					'refund': '退款售后',
					'closed': '已取消',
				},
			}
		},
		created: function() {
			if (this.$route.query.searchlist) {
				this.searchlist = JSON.parse(this.$route.query.searchlist);
				this.startdate = this.searchlist.startdate;
				this.enddate = this.searchlist.enddate;
			}
			this.initialize();
		},
		methods: {
			moment,
			initialize() {
				var self = this;
				var params = {
					searchlist: this.searchlist,
					startpage: this.startpage,
					pageSize: this.pageSize,
					shopkeeper_id:this.shopkeeper_id
				};
				this.$axios.get('/bd/tradelist', {
					params: params
				}).then(function(res) {
					self.tradelist = res.data.tradelist;
					self.tradesum = res.data.counttrade;

				});
			},
			onShowSizeChange(current, pageSize) {
				this.pageSize = pageSize;
				this.startpage = this.pageSize * (current - 1);
				this.endpage = this.pageSize * current;
				this.initialize();
				this.$router.push({
					name: 'bdtrade',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
						shopkeeper_id:this.shopkeeper_id
					}
				})

			},
			pageChange(pageNumber) {
				this.startpage = this.pageSize * (pageNumber - 1);
				this.endpage = this.pageSize * pageNumber;
				this.initialize();
				this.$router.push({
					name: 'bdtrade',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
						shopkeeper_id:this.shopkeeper_id
					}
				})
			},
			searchbtn() {
				this.startpage = 0;
				this.endpage = this.pageSize;
				// this.pageSize = 10;
				this.initialize();
				this.$router.push({
					name: 'bdtrade',
					query: {
						pageSize: this.pageSize,
						startpage: this.startpage,
						endpage: this.endpage,
						searchlist: JSON.stringify(this.searchlist),
						shopkeeper_id:this.shopkeeper_id
					}
				})
			},
			changetime(date, dateString) {
				this.searchlist.startdate = dateString[0];
				this.searchlist.enddate = dateString[1];

			},
			gotodetails(id) {
				this.$router.push({
					name: 'bdtradeinfo',
					query: {
						id: id
					}
				})
			},


		},

	};
</script>

<style>

	.bdtrade .contentcard {
		padding: 24px 50px;
		background-color: #fff;
		border-radius: 5px;
		margin-bottom: 20px;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// index.vue?a0f1b9a0